/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
  FormikProvider,
  useField,
  type FormikContextType,
  type FormikErrors,
} from 'formik'
import DatePicker from 'react-datepicker'

interface FormCalendar {
  className?: string
  name: string
  isError?:
    | string
    | false
    | FormikErrors<any>
    | string[]
    | FormikErrors<any>[]
    | undefined
  maxDate?: Date
  minDate?: Date
  filterDate?: (date: Date) => boolean
  locale?: string
  formik: FormikContextType<any>
  calendarClassName?: string
  onChangeCalendar?: (e: Date) => void
  calendarStartDay?: number
  placeholder?: string
  showIcon?: boolean
  peekNextMonth?: boolean
  showMonthDropdown?: boolean
  showYearDropdown?: boolean
}

function Calendar({
  name,
  isError = false,
  filterDate = () => true,
  calendarClassName,
  onChangeCalendar,
  calendarStartDay = 0,
  minDate,
  placeholder,
  showIcon = false,
  peekNextMonth = false,
  showMonthDropdown = false,
  showYearDropdown = false,
}: Omit<FormCalendar, 'formik'>) {
  const [, { value }, helpers] = useField(name)

  const { setValue } = helpers
  const onChangeDatePicker = (date: Date) => {
    setValue(date)
    onChangeCalendar && onChangeCalendar(date)
  }

  return (
    <DatePicker
      key={value?.toString()}
      selected={value}
      onChange={onChangeDatePicker}
      filterDate={filterDate}
      dateFormat='dd/MM/yyyy'
      minDate={minDate}
      peekNextMonth={peekNextMonth}
      showMonthDropdown={showMonthDropdown}
      showYearDropdown={showYearDropdown}
      dropdownMode='select'
      className={`${
        isError ? '!border-primary-second' : ''
      } h-[48px] w-full cursor-pointer rounded-lg border !border-dark-200 bg-white py-2.5 pl-4 pr-14 text-fieldInput tracking-wide outline-none transition-all  duration-300 placeholder:text-fieldInput placeholder:text-dark-400 placeholder:text-dark-400/70`}
      placeholderText={placeholder}
      calendarClassName={calendarClassName}
      calendarStartDay={calendarStartDay}
      showIcon={showIcon}
      scrollableYearDropdown
      wrapperClassName='w-full pr-[4px]'
    />
  )
}

export function FormCalendar({ formik, ...props }: FormCalendar) {
  return (
    <FormikProvider value={formik}>
      <Calendar {...props} />
    </FormikProvider>
  )
}

export default FormCalendar
